import React, {useState} from "react";
import {EventBus} from "../../util/EventBus";
import {FormattedMessage} from "react-intl";


function ErrorModal() {

    const visible = "visible";
    const hidden = "hidden";
    const [currentStyle, setCurrentStyle] = useState(hidden);
    const [title, setTitle] = useState("");
    const [message, setMessage] = useState("");
    const [buttonText, setButtonText] = useState("");

    const openModal = (title, message, buttonText) => {
        setCurrentStyle(visible);
        setTitle(title);
        setMessage(message);
        setButtonText(buttonText);
    }
    const closeModal = () => {
        setCurrentStyle(hidden);

    }

    React.useEffect(() => {
        EventBus.on("genericErrorMsg", (data) => {
            openModal(<FormattedMessage id="Oooops"/>, <FormattedMessage id="SomethingWentWrong"/>, <FormattedMessage id="OkGotIt"/>);
        });

        // Specify how to clean up after this effect:
        return function cleanup() {
            EventBus.remove("genericErrorMsg");
        };
    },[]);


    return (
        <>
            <div className={currentStyle+" modal-overlay "} onClick={(e)=> closeModal()}>   </div>
            <div className="modal error-modal">
                    <div className="row">
                        <div className="modal-title">{title}</div>
                    </div>
                <div className="row">
                    <p className="modal-text">{message}</p>
                </div>
                        <a className="btn btn-default mt-20" target="_blank" onClick={()=>closeModal()}>{buttonText}</a>
            </div>
        </>



    );

}



export default ErrorModal;
